import styles from './HorizontalDivider.module.css'

export default function HorizontalDivider() {
    return (
        <hr className={styles.root}/>
    )
}
